import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { LandingFixService } from '../../../shared/services/landing-fix.service';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import Chart from 'chart.js';
import { ContactService } from 'src/app/shared/services/contact.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';

// --- OBJETO DE TRADUCCIONES (ES / EN / PT) ---
const translations = {
  es: {
    // General
    mainTitle: 'Planes y Módulos ngCloud',
    subtitle: 'Cotiza y planifica tu mejor opción para la gestión de servicios IT.',
    languageLabel: 'Idioma',
    regionLabel: 'Región',

    // Tabs
    tabModules: 'Descripción de Módulos',
    tabQuotes: 'Cotizaciones',
    tabCalculator: 'Calculadora',
    tabCharts: 'Gráficos',
    tabAbout: 'Acerca de',

    // Módulos - Intro
    platformTitle: '🚀 Nuestra plataforma',
    platformDesc: 'Ofrecemos una potente plataforma SaaS que incluye módulos especializados para la gestión integral de servicios TI y operaciones empresariales.',

    // Módulo Cotizaciones
    modQuoteTitle: 'Sistema de Gestión de Cotizaciones ngCloud',
    modQuoteDesc: 'Solución robusta para optimizar el ciclo de vida de sus cotizaciones, desde la generación hasta la facturación.',
    modQuoteListTitle1: 'Gestión de Estados:', modQuoteListDesc1: 'Rastreo en tiempo real (Pendiente, Aprobado, etc.).',
    modQuoteListTitle2: 'Auditoría:', modQuoteListDesc2: 'Historial detallado de modificaciones.',
    modQuoteListTitle3: 'Reportería:', modQuoteListDesc3: 'Exportación a Excel y métricas clave.',
    modQuoteListTitle4: 'Dashboards:', modQuoteListDesc4: 'Paneles visuales para KPIs.',
    modQuoteListTitle5: 'Centralización:', modQuoteListDesc5: 'Datos de clientes y productos en un solo lugar.',
    modQuoteListTitle6: 'Flexibilidad:', modQuoteListDesc6: 'Adaptable a diferentes tipos de servicios.',
    modQuoteListTitle7: 'Eficiencia:', modQuoteListDesc7: 'Automatización para reducir carga manual.',

    // Módulo Incidentes
    modIncidentTitle: 'Módulo de Gestión de Incidentes ngCloud',
    modIncidentDesc: 'Optimice la respuesta y resolución de incidentes minimizando el impacto operativo.',
    modIncidentListTitle1: 'Centralización:', modIncidentListDesc1: 'Plataforma unificada.',
    modIncidentListTitle2: 'Clasificación:', modIncidentListDesc2: 'Priorización y estados.',
    modIncidentListTitle3: 'Alertas:', modIncidentListDesc3: 'Notificaciones en tiempo real.',
    modIncidentListTitle4: 'Seguimiento:', modIncidentListDesc4: 'Cronología completa.',
    modIncidentListTitle5: 'Informes:', modIncidentListDesc5: 'Analíticas de resolución.',
    modIncidentListTitle6: 'Colaboración:', modIncidentListDesc6: 'Comunicación entre equipos.',
    modIncidentListTitle7: 'Integración:', modIncidentListDesc7: 'Conexión con herramientas existentes.',
    keyBenefits: 'Beneficios Clave:',
    modIncidentBenefitTitle1: 'Menor Inactividad:', modIncidentBenefitDesc1: 'Resolución rápida.',
    modIncidentBenefitTitle2: 'Satisfacción:', modIncidentBenefitDesc2: 'Respuesta eficiente al usuario.',
    modIncidentBenefitTitle3: 'Recursos:', modIncidentBenefitDesc3: 'Asignación inteligente.',
    modIncidentBenefitTitle4: 'Cumplimiento:', modIncidentBenefitDesc4: 'Registro auditable.',
    modIncidentBenefitTitle5: 'Visibilidad:', modIncidentBenefitDesc5: 'Control total del estado.',

    // Módulo Problemas
    modProblemTitle: 'Módulo de Gestión de Problemas ngCloud',
    modProblemDesc: 'Identifique la causa raíz de incidentes recurrentes para prevenir su reaparición.',
    modProblemListTitle1: 'Causa Raíz:', modProblemListDesc1: 'Análisis profundo de incidentes.',
    modProblemListTitle2: 'Base de Conocimiento:', modProblemListDesc2: 'Soluciones y workarounds.',
    modProblemListTitle3: 'Gestión de Cambios:', modProblemListDesc3: 'Vinculación con soluciones permanentes.',
    modProblemListTitle4: 'Tendencias:', modProblemListDesc4: 'Identificación de patrones.',
    modProblemListTitle5: 'Informes:', modProblemListDesc5: 'Estado y progreso de soluciones.',
    modProblemListTitle6: 'Integración:', modProblemListDesc6: 'Escalado fluido desde incidentes.',
    modProblemFooter: 'Mejore la estabilidad de su infraestructura con una gestión efectiva.',

    // Módulo Inventario
    modInventoryTitle: 'Módulo de Gestión de Inventario ngCloud',
    modInventoryDesc: 'Control exhaustivo de activos, hardware, software y licencias.',
    modInventoryListTitle1: 'Registro:', modInventoryListDesc1: 'Detalle completo de activos.',
    modInventoryListTitle2: 'Trazabilidad:', modInventoryListDesc2: 'Ciclo de vida completo.',
    modInventoryListTitle3: 'Códigos:', modInventoryListDesc3: 'Lectura de QR/Barras.',
    modInventoryListTitle4: 'Alertas:', modInventoryListDesc4: 'Stock bajo y fin de vida útil.',
    modInventoryListTitle5: 'Reportes:', modInventoryListDesc5: 'Auditorías y depreciación.',
    modInventoryListTitle6: 'Conectividad:', modInventoryListDesc6: 'Integrado con Incidentes.',
    modInventoryFooter: 'Gestione sus activos de forma inteligente.',

    // Módulo Tareas
    modTaskTitle: 'Módulo de Gestión de Tareas ngCloud',
    modTaskDesc: 'Organización y seguimiento de actividades operativas y proyectos.',
    modTaskListTitle1: 'Asignación:', modTaskListDesc1: 'Responsables y fechas límite.',
    modTaskListTitle2: 'Progreso:', modTaskListDesc2: 'Monitoreo en tiempo real.',
    modTaskListTitle3: 'Notificaciones:', modTaskListDesc3: 'Alertas de vencimiento.',
    modTaskListTitle4: 'Colaboración:', modTaskListDesc4: 'Archivos y comentarios.',
    modTaskListTitle5: 'Priorización:', modTaskListDesc5: 'Dependencias lógicas.',
    modTaskListTitle6: 'Dashboards:', modTaskListDesc6: 'Rendimiento del equipo.',
    modTaskFooter: 'Optimice la productividad de su equipo.',

    // Módulo Gemini
    modGeminiTitle: 'Agente Virtual con IA de Gemini ngCloud',
    modGeminiIntro: '¡Redefiniendo la gestión con inteligencia artificial! 🚀',
    modGeminiDesc: 'Agente Virtual con IA de Gemini que automatiza tareas cruciales.',
    modGeminiCapabilities: 'Capacidades clave:',
    modGeminiListTitle1: 'Automatización:', modGeminiListDesc1: 'Clasifica y actualiza descripciones.',
    modGeminiListTitle2: 'Multicanal:', modGeminiListDesc2: 'Manejo unificado de tickets.',
    modGeminiListTitle3: 'Tiempo Real:', modGeminiListDesc3: 'SLA y comentarios dinámicos.',
    modGeminiListTitle4: 'Flexibilidad:', modGeminiListDesc4: 'Interfaz adaptable.',
    alsoOffers: 'También ofrecemos:',
    offer1: 'Catálogo dinámico con SLA/OLA.',
    offer2: 'Gestión de tiempos y notificaciones.',
    offer3: 'Exportación de datos a Excel.',
    businessAdapt: 'Adaptable a banca, minería, salud y retail.',
    contactPrompt: '¿Listo para transformar su gestión? Contáctenos:',
    elevateProductivity: '¡Eleva tu productividad con la tecnología del futuro! ✨',

    promoVideosTitle: 'Videos Promocionales',

    // Cotizaciones Tab
    costDetailsTitle: 'Detalle de Costos por Plan',

    // Gráficos Tab
    priceComparisonTitle: 'Comparación de Costos por Plan',
    selectPlan: 'Seleccione un Plan',

    // Calculadora Tab
    planRecommenderTitle: 'Encuentra el Plan Ideal',
    planRecommenderSubtitle: 'Ingresa el número de usuarios para recomendarte el mejor plan.',
    totalUsersPlaceholder: 'Número total de usuarios',
    calculatingPlan: 'Calcular Plan',
    recommendationResultTitle: 'Para',
    recommendationResultTitleUsers: 'usuarios, el plan recomendado es',
    modulesCost: 'Costo Módulos:',
    machineCost: 'Costo Máquina:',
    storageCost: 'Costo Storage:',
    geminiCost: 'Costo IA Gemini:',
    subtotalNet: 'Subtotal (Neto):',
    ivaLabel: 'IVA',
    finalTotal: 'Total Final:',
    includedModules: 'Módulos Incluidos:',
    officialCalcLink: 'Enlaces a calculadoras oficiales:',
    calcAzure: '🧮 Calculadora Microsoft Azure',
    calcAws: '🧮 Calculadora AWS',
    calcDisclaimer: 'Los precios pueden variar según necesidades específicas.',

    customCalculatorTitle: 'Calculadora Personalizada',
    customCalculatorSubtitle: 'Arma tu plan a medida seleccionando componentes.',
    step1Title: '1. Plan Base', step1Subtitle: 'Punto de partida según escala.',
    step2Title: '2. Máquina', step2Subtitle: 'Infraestructura subyacente.',
    step3Title: '3. Módulos', step3Subtitle: 'Potencie su solución (opcional).',
    step4Title: '4. Almacenamiento', step4Subtitle: 'Espacio escalable.',
    step5Title: '5. IA GEMINI', step5Enable: 'Habilitar', step5Subtitle: 'Potencia de Inteligencia Artificial.',

    costSummaryTitle: 'Resumen de Costos',
    contactUs: 'CONTÁCTENOS',
    placeholderName: 'Nombre Completo',
    placeholderPhone: 'Teléfono',
    placeholderEmail: 'Correo Electrónico',
    errorEmail: 'Ingrese un correo válido.',
    sendQuote: 'Enviar Cotización',

    // Email Labels
    emailTitle: 'Resumen de Cotización ngCloud',
    emailConfigTitle: 'Configuración Seleccionada',
    emailBasePlan: 'Plan Base',
    emailMachine: 'Máquina',
    emailStorage: 'Almacenamiento',
    emailGemini: 'Plan IA Gemini',
    emailGeminiDisabled: 'No habilitado',
    emailModulesTitle: 'Módulos Seleccionados',
    emailModuleHeader: 'Módulo',
    emailCostHeader: 'Costo',
    emailSummaryTitle: 'Resumen de Costos',
    emailDisclaimer: 'Esta es una cotización preliminar. Los valores pueden variar.',

    // About (ACTUALIZADO)
    aboutTitle: 'Acerca de',
    aboutWhoWeAre: '¿Quiénes somos? En ngCloud, somos una empresa especializada en el desarrollo de soluciones de software a medida, enfocadas en la automatización de procesos para mejorar la gestión, reducir costos y potenciar la eficiencia operativa de nuestros clientes. Contamos con un equipo de profesionales proactivos, autodidactas y altamente comprometidos, con sólida experiencia en las tecnologías más avanzadas del mercado.',

    aboutMissionTitle: 'Nuestra Misión',
    aboutMissionDesc: 'Impulsar la transformación digital de organizaciones a través de soluciones tecnológicas innovadoras, escalables y seguras. Nos enfocamos en optimizar procesos, mejorar la eficiencia operativa y fortalecer la competitividad de nuestros clientes en un entorno global en constante evolución. Nuestra misión es acompañar a las empresas en su camino hacia la automatización inteligente, permitiéndoles alcanzar nuevos niveles de rendimiento, agilidad y sostenibilidad.',

    aboutVisionTitle: 'Nuestra Visión',
    aboutVisionDesc: 'Ser un referente global en la industria tecnológica, reconocidos por nuestra excelencia, compromiso y capacidad para resolver desafíos complejos. Aspiramos a liderar la evolución digital, manteniéndonos a la vanguardia de las tendencias emergentes y anticipándonos a las necesidades del mercado. Buscamos generar un impacto positivo y sostenible en nuestros clientes, colaboradores y en el ecosistema empresarial en su conjunto.',

    aboutTechTitle: 'Tecnologías y Experiencia',

    aboutTechListTitle1: 'Lenguajes y Tecnologías:',
    aboutTechListDesc1: 'Contamos con experiencia en una amplia gama de lenguajes de programación y frameworks modernos, lo que nos permite adaptarnos a cualquier entorno tecnológico y requerimiento específico.',

    aboutTechListTitle2: 'Bases de Datos:',
    aboutTechListDesc2: 'Trabajamos con los principales motores de bases de datos relacionales y no relacionales del mercado, asegurando compatibilidad y eficiencia en la gestión de datos, sin importar la plataforma utilizada.',

    aboutTechListTitle3: 'Sistemas y Conectividad:',
    aboutTechListDesc3: 'Nuestra arquitectura está diseñada para integrarse de forma ágil y segura con cualquier sistema, herramienta o servicio del ecosistema digital, incluyendo soluciones empresariales, APIs, plataformas ITSM, y entornos híbridos o en la nube.',

    aboutTechListTitle4: 'Desarrollo de Software:',
    aboutTechListDesc4: 'Creamos soluciones a medida para plataformas web, móviles y sistemas integrados, alineadas con los objetivos estratégicos de cada cliente y con estándares internacionales de calidad y seguridad.'
  },
  en: {
    // General
    mainTitle: 'ngCloud Plans and Modules',
    subtitle: 'Quote and plan your best option for IT service management.',
    languageLabel: 'Language',
    regionLabel: 'Region',

    // Tabs
    tabModules: 'Modules Description',
    tabQuotes: 'Quotes',
    tabCalculator: 'Calculator',
    tabCharts: 'Charts',
    tabAbout: 'About',

    // Modules - Intro
    platformTitle: '🚀 Our Platform',
    platformDesc: 'We offer a powerful SaaS platform including specialized modules for IT service management and business operations.',

    // Quote Module
    modQuoteTitle: 'ngCloud Quote Management System',
    modQuoteDesc: 'Robust solution to optimize your quote lifecycle, from generation to invoicing.',
    modQuoteListTitle1: 'Status Management:', modQuoteListDesc1: 'Real-time tracking (Pending, Approved, etc.).',
    modQuoteListTitle2: 'Audit:', modQuoteListDesc2: 'Detailed modification history.',
    modQuoteListTitle3: 'Reporting:', modQuoteListDesc3: 'Excel export and key metrics.',
    modQuoteListTitle4: 'Dashboards:', modQuoteListDesc4: 'Visual panels for KPIs.',
    modQuoteListTitle5: 'Centralization:', modQuoteListDesc5: 'Client and product data in one place.',
    modQuoteListTitle6: 'Flexibility:', modQuoteListDesc6: 'Adaptable to different service types.',
    modQuoteListTitle7: 'Efficiency:', modQuoteListDesc7: 'Automation to reduce manual workload.',

    // Incident Module
    modIncidentTitle: 'ngCloud Incident Management Module',
    modIncidentDesc: 'Optimize incident response and resolution minimizing operational impact.',
    modIncidentListTitle1: 'Centralization:', modIncidentListDesc1: 'Unified platform.',
    modIncidentListTitle2: 'Classification:', modIncidentListDesc2: 'Prioritization and status.',
    modIncidentListTitle3: 'Alerts:', modIncidentListDesc3: 'Real-time notifications.',
    modIncidentListTitle4: 'Tracking:', modIncidentListDesc4: 'Complete chronology.',
    modIncidentListTitle5: 'Reports:', modIncidentListDesc5: 'Resolution analytics.',
    modIncidentListTitle6: 'Collaboration:', modIncidentListDesc6: 'Team communication.',
    modIncidentListTitle7: 'Integration:', modIncidentListDesc7: 'Connects with existing tools.',
    keyBenefits: 'Key Benefits:',
    modIncidentBenefitTitle1: 'Less Downtime:', modIncidentBenefitDesc1: 'Faster resolution.',
    modIncidentBenefitTitle2: 'Satisfaction:', modIncidentBenefitDesc2: 'Efficient user response.',
    modIncidentBenefitTitle3: 'Resources:', modIncidentBenefitDesc3: 'Intelligent allocation.',
    modIncidentBenefitTitle4: 'Compliance:', modIncidentBenefitDesc4: 'Auditable records.',
    modIncidentBenefitTitle5: 'Visibility:', modIncidentBenefitDesc5: 'Full status control.',

    // Problem Module
    modProblemTitle: 'ngCloud Problem Management Module',
    modProblemDesc: 'Identify root causes of recurrent incidents to prevent recurrence.',
    modProblemListTitle1: 'Root Cause:', modProblemListDesc1: 'Deep incident analysis.',
    modProblemListTitle2: 'Knowledge Base:', modProblemListDesc2: 'Solutions and workarounds.',
    modProblemListTitle3: 'Change Mgmt:', modProblemListDesc3: 'Link to permanent solutions.',
    modProblemListTitle4: 'Trends:', modProblemListDesc4: 'Pattern identification.',
    modProblemListTitle5: 'Reports:', modProblemListDesc5: 'Solution status and progress.',
    modProblemListTitle6: 'Integration:', modProblemListDesc6: 'Fluid escalation from incidents.',
    modProblemFooter: 'Improve infrastructure stability with effective management.',

    // Inventory Module
    modInventoryTitle: 'ngCloud Inventory Management Module',
    modInventoryDesc: 'Exhaustive control of assets, hardware, software, and licenses.',
    modInventoryListTitle1: 'Registry:', modInventoryListDesc1: 'Complete asset details.',
    modInventoryListTitle2: 'Traceability:', modInventoryListDesc2: 'Full lifecycle.',
    modInventoryListTitle3: 'Codes:', modInventoryListDesc3: 'QR/Barcode reading.',
    modInventoryListTitle4: 'Alerts:', modInventoryListDesc4: 'Low stock and end-of-life.',
    modInventoryListTitle5: 'Reports:', modInventoryListDesc5: 'Audits and depreciation.',
    modInventoryListTitle6: 'Connectivity:', modInventoryListDesc6: 'Integrated with Incidents.',
    modInventoryFooter: 'Manage your assets intelligently.',

    // Task Module
    modTaskTitle: 'ngCloud Task Management Module',
    modTaskDesc: 'Organization and tracking of operational activities and projects.',
    modTaskListTitle1: 'Assignment:', modTaskListDesc1: 'Owners and deadlines.',
    modTaskListTitle2: 'Progress:', modTaskListDesc2: 'Real-time monitoring.',
    modTaskListTitle3: 'Notifications:', modTaskListDesc3: 'Due date alerts.',
    modTaskListTitle4: 'Collaboration:', modTaskListDesc4: 'Files and comments.',
    modTaskListTitle5: 'Prioritization:', modTaskListDesc5: 'Logical dependencies.',
    modTaskListTitle6: 'Dashboards:', modTaskListDesc6: 'Team performance.',
    modTaskFooter: 'Optimize your team productivity.',

    // Gemini Module
    modGeminiTitle: 'ngCloud Gemini AI Virtual Agent',
    modGeminiIntro: 'Redefining management with Artificial Intelligence! 🚀',
    modGeminiDesc: 'Gemini AI Virtual Agent automating crucial tasks.',
    modGeminiCapabilities: 'Key Capabilities:',
    modGeminiListTitle1: 'Automation:', modGeminiListDesc1: 'Classifies and updates descriptions.',
    modGeminiListTitle2: 'Multi-channel:', modGeminiListDesc2: 'Unified ticket handling.',
    modGeminiListTitle3: 'Real Time:', modGeminiListDesc3: 'Dynamic SLA and comments.',
    modGeminiListTitle4: 'Flexibility:', modGeminiListDesc4: 'Adaptive interface.',
    alsoOffers: 'We also offer:',
    offer1: 'Dynamic catalog with SLA/OLA.',
    offer2: 'Time management and notifications.',
    offer3: 'Data export to Excel.',
    businessAdapt: 'Adaptable to banking, mining, health, and retail.',
    contactPrompt: 'Ready to transform your management? Contact us:',
    elevateProductivity: 'Elevate your productivity with future technology! ✨',

    promoVideosTitle: 'Promotional Videos',

    // Quotes Tab
    costDetailsTitle: 'Cost Details by Plan',

    // Charts Tab
    priceComparisonTitle: 'Cost Comparison by Plan',
    selectPlan: 'Select a Plan',

    // Calculator Tab
    planRecommenderTitle: 'Find the Ideal Plan',
    planRecommenderSubtitle: 'Enter the number of users to recommend the best plan.',
    totalUsersPlaceholder: 'Total number of users',
    calculatingPlan: 'Calculate Plan',
    recommendationResultTitle: 'For',
    recommendationResultTitleUsers: 'users, the recommended plan is',
    modulesCost: 'Modules Cost:',
    machineCost: 'Machine Cost:',
    storageCost: 'Storage Cost:',
    geminiCost: 'Gemini AI Cost:',
    subtotalNet: 'Subtotal (Net):',
    ivaLabel: 'Tax',
    finalTotal: 'Final Total:',
    includedModules: 'Included Modules:',
    officialCalcLink: 'Official calculator links:',
    calcAzure: '🧮 Microsoft Azure Calculator',
    calcAws: '🧮 AWS Calculator',
    calcDisclaimer: 'Prices may vary based on specific needs.',

    customCalculatorTitle: 'Custom Calculator',
    customCalculatorSubtitle: 'Build your custom plan by selecting components.',
    step1Title: '1. Base Plan', step1Subtitle: 'Starting point based on scale.',
    step2Title: '2. Machine', step2Subtitle: 'Underlying infrastructure.',
    step3Title: '3. Modules', step3Subtitle: 'Power up your solution (optional).',
    step4Title: '4. Storage', step4Subtitle: 'Scalable space.',
    step5Title: '5. GEMINI AI', step5Enable: 'Enable', step5Subtitle: 'Artificial Intelligence Power.',

    costSummaryTitle: 'Cost Summary',
    contactUs: 'CONTACT US',
    placeholderName: 'Full Name',
    placeholderPhone: 'Phone',
    placeholderEmail: 'Email',
    errorEmail: 'Enter a valid email.',
    sendQuote: 'Send Quote',

    // Email Labels
    emailTitle: 'ngCloud Quote Summary',
    emailConfigTitle: 'Selected Configuration',
    emailBasePlan: 'Base Plan',
    emailMachine: 'Machine',
    emailStorage: 'Storage',
    emailGemini: 'Gemini AI Plan',
    emailGeminiDisabled: 'Not enabled',
    emailModulesTitle: 'Selected Modules',
    emailModuleHeader: 'Module',
    emailCostHeader: 'Cost',
    emailSummaryTitle: 'Cost Summary',
    emailDisclaimer: 'This is a preliminary quote. Values may vary.',

    // About (UPDATED)
    aboutTitle: 'About',
    aboutWhoWeAre: 'Who are we? At ngCloud, we are a company specialized in the development of custom software solutions, focused on process automation to improve management, reduce costs, and enhance operational efficiency for our clients. We have a team of proactive, self-taught, and highly committed professionals with solid experience in the most advanced technologies on the market.',

    aboutMissionTitle: 'Our Mission',
    aboutMissionDesc: 'To drive the digital transformation of organizations through innovative, scalable, and secure technological solutions. We focus on optimizing processes, improving operational efficiency, and strengthening our clients\' competitiveness in a constantly evolving global environment. Our mission is to accompany companies on their path to intelligent automation, allowing them to reach new levels of performance, agility, and sustainability.',

    aboutVisionTitle: 'Our Vision',
    aboutVisionDesc: 'To be a global benchmark in the technology industry, recognized for our excellence, commitment, and ability to solve complex challenges. We aspire to lead digital evolution, staying at the forefront of emerging trends and anticipating market needs. We seek to generate a positive and sustainable impact on our clients, collaborators, and the business ecosystem as a whole.',

    aboutTechTitle: 'Technologies and Experience',

    aboutTechListTitle1: 'Languages and Technologies:',
    aboutTechListDesc1: 'We have experience in a wide range of modern programming languages and frameworks, allowing us to adapt to any technological environment and specific requirement.',

    aboutTechListTitle2: 'Databases:',
    aboutTechListDesc2: 'We work with the main relational and non-relational database engines on the market, ensuring compatibility and efficiency in data management, regardless of the platform used.',

    aboutTechListTitle3: 'Systems and Connectivity:',
    aboutTechListDesc3: 'Our architecture is designed to integrate agilely and securely with any system, tool, or service in the digital ecosystem, including enterprise solutions, APIs, ITSM platforms, and hybrid or cloud environments.',

    aboutTechListTitle4: 'Software Development:',
    aboutTechListDesc4: 'We create custom solutions for web, mobile, and embedded platforms, aligned with each client\'s strategic objectives and international quality and security standards.'
  },
  pt: {
    // General
    mainTitle: 'Planos e Módulos ngCloud',
    subtitle: 'Cote e planeje sua melhor opção para gestão de serviços de TI.',
    languageLabel: 'Idioma',
    regionLabel: 'Região',

    // Tabs
    tabModules: 'Descrição dos Módulos',
    tabQuotes: 'Cotações',
    tabCalculator: 'Calculadora',
    tabCharts: 'Gráficos',
    tabAbout: 'Sobre',

    // Modules - Intro
    platformTitle: '🚀 Nossa Plataforma',
    platformDesc: 'Oferecemos uma poderosa plataforma SaaS que inclui módulos especializados para gestão integral de serviços de TI e operações empresariais.',

    // Quote Module
    modQuoteTitle: 'Sistema de Gestão de Cotações ngCloud',
    modQuoteDesc: 'Solução robusta para otimizar o ciclo de vida de suas cotações, desde a geração até o faturamento.',
    modQuoteListTitle1: 'Gestão de Estados:', modQuoteListDesc1: 'Rastreamento em tempo real (Pendente, Aprovado, etc.).',
    modQuoteListTitle2: 'Auditoria:', modQuoteListDesc2: 'Histórico detalhado de modificações.',
    modQuoteListTitle3: 'Relatórios:', modQuoteListDesc3: 'Exportação para Excel e métricas chave.',
    modQuoteListTitle4: 'Dashboards:', modQuoteListDesc4: 'Painéis visuais para KPIs.',
    modQuoteListTitle5: 'Centralização:', modQuoteListDesc5: 'Dados de clientes e produtos em um só lugar.',
    modQuoteListTitle6: 'Flexibilidade:', modQuoteListDesc6: 'Adaptável a diferentes tipos de serviços.',
    modQuoteListTitle7: 'Eficiência:', modQuoteListDesc7: 'Automação para reduzir carga manual.',

    // Incident Module
    modIncidentTitle: 'Módulo de Gestão de Incidentes ngCloud',
    modIncidentDesc: 'Otimize a resposta e resolução de incidentes minimizando o impacto operacional.',
    modIncidentListTitle1: 'Centralização:', modIncidentListDesc1: 'Plataforma unificada.',
    modIncidentListTitle2: 'Classificação:', modIncidentListDesc2: 'Priorização e estados.',
    modIncidentListTitle3: 'Alertas:', modIncidentListDesc3: 'Notificações em tempo real.',
    modIncidentListTitle4: 'Rastreamento:', modIncidentListDesc4: 'Cronologia completa.',
    modIncidentListTitle5: 'Relatórios:', modIncidentListDesc5: 'Análises de resolução.',
    modIncidentListTitle6: 'Colaboração:', modIncidentListDesc6: 'Comunicação entre equipes.',
    modIncidentListTitle7: 'Integração:', modIncidentListDesc7: 'Conexão com ferramentas existentes.',
    keyBenefits: 'Benefícios Principais:',
    modIncidentBenefitTitle1: 'Menor Inatividade:', modIncidentBenefitDesc1: 'Resolução rápida.',
    modIncidentBenefitTitle2: 'Satisfação:', modIncidentBenefitDesc2: 'Resposta eficiente ao usuário.',
    modIncidentBenefitTitle3: 'Recursos:', modIncidentBenefitDesc3: 'Alocação inteligente.',
    modIncidentBenefitTitle4: 'Compliance:', modIncidentBenefitDesc4: 'Registro auditável.',
    modIncidentBenefitTitle5: 'Visibilidade:', modIncidentBenefitDesc5: 'Controle total do estado.',

    // Problem Module
    modProblemTitle: 'Módulo de Gestão de Problemas ngCloud',
    modProblemDesc: 'Identifique a causa raiz de incidentes recorrentes para prevenir sua reincidência.',
    modProblemListTitle1: 'Causa Raiz:', modProblemListDesc1: 'Análise profunda de incidentes.',
    modProblemListTitle2: 'Base de Conhecimento:', modProblemListDesc2: 'Soluções e workarounds.',
    modProblemListTitle3: 'Gestão de Mudanças:', modProblemListDesc3: 'Vínculo com soluções permanentes.',
    modProblemListTitle4: 'Tendências:', modProblemListDesc4: 'Identificação de padrões.',
    modProblemListTitle5: 'Relatórios:', modProblemListDesc5: 'Estado e progresso de soluções.',
    modProblemListTitle6: 'Integração:', modProblemListDesc6: 'Escalonamento fluido desde incidentes.',
    modProblemFooter: 'Melhore a estabilidade de sua infraestrutura com uma gestão eficaz.',

    // Inventory Module
    modInventoryTitle: 'Módulo de Gestão de Inventário ngCloud',
    modInventoryDesc: 'Controle exaustivo de ativos, hardware, software e licenças.',
    modInventoryListTitle1: 'Registro:', modInventoryListDesc1: 'Detalhe completo de ativos.',
    modInventoryListTitle2: 'Rastreabilidade:', modInventoryListDesc2: 'Ciclo de vida completo.',
    modInventoryListTitle3: 'Códigos:', modInventoryListDesc3: 'Leitura de QR/Barras.',
    modInventoryListTitle4: 'Alertas:', modInventoryListDesc4: 'Estoque baixo e fim de vida útil.',
    modInventoryListTitle5: 'Relatórios:', modInventoryListDesc5: 'Auditorias e depreciação.',
    modInventoryListTitle6: 'Conectividade:', modInventoryListDesc6: 'Integrado com Incidentes.',
    modInventoryFooter: 'Gerencie seus ativos de forma inteligente.',

    // Task Module
    modTaskTitle: 'Módulo de Gestão de Tarefas ngCloud',
    modTaskDesc: 'Organização e acompanhamento de atividades operacionais e projetos.',
    modTaskListTitle1: 'Atribuição:', modTaskListDesc1: 'Responsáveis e prazos.',
    modTaskListTitle2: 'Progresso:', modTaskListDesc2: 'Monitoramento em tempo real.',
    modTaskListTitle3: 'Notificações:', modTaskListDesc3: 'Alertas de vencimento.',
    modTaskListTitle4: 'Colaboração:', modTaskListDesc4: 'Arquivos e comentários.',
    modTaskListTitle5: 'Priorização:', modTaskListDesc5: 'Dependências lógicas.',
    modTaskListTitle6: 'Dashboards:', modTaskListDesc6: 'Desempenho da equipe.',
    modTaskFooter: 'Otimize a produtividade da sua equipe.',

    // Gemini Module
    modGeminiTitle: 'Agente Virtual com IA do Gemini ngCloud',
    modGeminiIntro: 'Redefinindo a gestão com Inteligência Artificial! 🚀',
    modGeminiDesc: 'Agente Virtual com IA do Gemini que automatiza tarefas cruciais.',
    modGeminiCapabilities: 'Capacidades Chave:',
    modGeminiListTitle1: 'Automação:', modGeminiListDesc1: 'Classifica e atualiza descrições.',
    modGeminiListTitle2: 'Multicanal:', modGeminiListDesc2: 'Manuseio unificado de tickets.',
    modGeminiListTitle3: 'Tempo Real:', modGeminiListDesc3: 'SLA e comentários dinâmicos.',
    modGeminiListTitle4: 'Flexibilidade:', modGeminiListDesc4: 'Interface adaptável.',
    alsoOffers: 'Também oferecemos:',
    offer1: 'Catálogo dinâmico com SLA/OLA.',
    offer2: 'Gestão de tempos e notificações.',
    offer3: 'Exportação de dados para Excel.',
    businessAdapt: 'Adaptável para bancos, mineração, saúde e varejo.',
    contactPrompt: 'Pronto para transformar sua gestão? Contate-nos:',
    elevateProductivity: 'Eleve sua produtividade com a tecnologia do futuro! ✨',

    promoVideosTitle: 'Vídeos Promocionais',

    // Quotes Tab
    costDetailsTitle: 'Detalhe de Custos por Plano',

    // Charts Tab
    priceComparisonTitle: 'Comparação de Custos por Plano',
    selectPlan: 'Selecione um Plano',

    // Calculator Tab
    planRecommenderTitle: 'Encontre o Plano Ideal',
    planRecommenderSubtitle: 'Insira o número de usuários para recomendar o melhor plano.',
    totalUsersPlaceholder: 'Número total de usuários',
    calculatingPlan: 'Calcular Plano',
    recommendationResultTitle: 'Para',
    recommendationResultTitleUsers: 'usuários, o plano recomendado é',
    modulesCost: 'Custo Módulos:',
    machineCost: 'Custo Máquina:',
    storageCost: 'Custo Armazenamento:',
    geminiCost: 'Custo IA Gemini:',
    subtotalNet: 'Subtotal (Líquido):',
    ivaLabel: 'Imposto',
    finalTotal: 'Total Final:',
    includedModules: 'Módulos Incluídos:',
    officialCalcLink: 'Links para calculadoras oficiais:',
    calcAzure: '🧮 Calculadora Microsoft Azure',
    calcAws: '🧮 Calculadora AWS',
    calcDisclaimer: 'Os preços podem variar de acordo com as necessidades específicas.',

    customCalculatorTitle: 'Calculadora Personalizada',
    customCalculatorSubtitle: 'Monte seu plano sob medida selecionando componentes.',
    step1Title: '1. Plano Base', step1Subtitle: 'Ponto de partida conforme escala.',
    step2Title: '2. Máquina', step2Subtitle: 'Infraestrutura subjacente.',
    step3Title: '3. Módulos', step3Subtitle: 'Potencialize sua solução (opcional).',
    step4Title: '4. Armazenamento', step4Subtitle: 'Espaço escalável.',
    step5Title: '5. IA GEMINI', step5Enable: 'Habilitar', step5Subtitle: 'Poder da Inteligência Artificial.',

    costSummaryTitle: 'Resumo de Custos',
    contactUs: 'CONTATE-NOS',
    placeholderName: 'Nome Completo',
    placeholderPhone: 'Telefone',
    placeholderEmail: 'E-mail',
    errorEmail: 'Insira um e-mail válido.',
    sendQuote: 'Enviar Cotação',

    // Email Labels
    emailTitle: 'Resumo de Cotação ngCloud',
    emailConfigTitle: 'Configuração Selecionada',
    emailBasePlan: 'Plano Base',
    emailMachine: 'Máquina',
    emailStorage: 'Armazenamento',
    emailGemini: 'Plano IA Gemini',
    emailGeminiDisabled: 'Não habilitado',
    emailModulesTitle: 'Módulos Selecionados',
    emailModuleHeader: 'Módulo',
    emailCostHeader: 'Custo',
    emailSummaryTitle: 'Resumo de Custos',
    emailDisclaimer: 'Esta é uma cotação preliminar. Os valores podem variar.',

    // About (ATUALIZADO)
    aboutTitle: 'Sobre',
    aboutWhoWeAre: 'Quem somos? Na ngCloud, somos uma empresa especializada no desenvolvimento de soluções de software sob medida, focadas na automação de processos para melhorar a gestão, reduzir custos e potencializar a eficiência operacional de nossos clientes. Contamos com uma equipe de profissionais proativos, autodidatas e altamente comprometidos, com sólida experiência nas tecnologias mais avançadas do mercado.',

    aboutMissionTitle: 'Nossa Missão',
    aboutMissionDesc: 'Impulsionar a transformação digital de organizações através de soluções tecnológicas inovadoras, escaláveis e seguras. Focamos em otimizar processos, melhorar a eficiência operacional e fortalecer a competitividade de nossos clientes em um ambiente global em constante evolução. Nossa missão é acompanhar as empresas em seu caminho para a automação inteligente, permitindo-lhes alcançar novos níveis de desempenho, agilidade e sustentabilidade.',

    aboutVisionTitle: 'Nossa Visão',
    aboutVisionDesc: 'Ser uma referência global na indústria tecnológica, reconhecidos por nossa excelência, compromisso e capacidade de resolver desafios complexos. Aspiramos liderar a evolução digital, mantendo-nos na vanguarda das tendências emergentes e antecipando as necessidades do mercado. Buscamos gerar um impacto positivo e sustentável em nossos clientes, colaboradores e no ecossistema empresarial como um todo.',

    aboutTechTitle: 'Tecnologias e Experiência',

    aboutTechListTitle1: 'Linguagens e Tecnologias:',
    aboutTechListDesc1: 'Temos experiência em uma ampla gama de linguagens de programação e frameworks modernos, o que nos permite adaptar a qualquer ambiente tecnológico e requisito específico.',

    aboutTechListTitle2: 'Banco de Dados:',
    aboutTechListDesc2: 'Trabalhamos com os principais motores de banco de dados relacionais e não relacionais do mercado, garantindo compatibilidade e eficiência na gestão de dados, independentemente da plataforma utilizada.',

    aboutTechListTitle3: 'Sistemas e Conectividade:',
    aboutTechListDesc3: 'Nossa arquitetura é projetada para integrar-se de forma ágil e segura com qualquer sistema, ferramenta ou serviço do ecossistema digital, incluindo soluções empresariais, APIs, plataformas ITSM e ambientes híbridos ou na nuvem.',

    aboutTechListTitle4: 'Desenvolvimento de Software:',
    aboutTechListDesc4: 'Criamos soluções sob medida para plataformas web, móveis e sistemas integrados, alinhadas com os objetivos estratégicos de cada cliente e com padrões internacionais de qualidade e segurança.'
  }
};

@Component({
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrls: ['./home-one.component.scss']
})
export class HomeOneComponent implements OnInit, OnDestroy, AfterViewInit {

  public activeTab: string = 'modulos-videos';
  public recommendationResult: boolean = false;
  private myChart: Chart;
  sendEmail: boolean = false;
  contactForm: FormGroup;

  // --- LÓGICA DE INTERNACIONALIZACIÓN (i18n) Y MONEDA ---
  public currentLang: 'es' | 'en' | 'pt' = 'es';

  public countries: any[] = [
    // --- Precios Base (1.0x) ---
    { code: 'cl', name: 'Chile', flag: '🇨🇱', currency: 'UF', useUF: true, lang: 'es', ivaRate: 0.19, priceMultiplier: 1.0 },
    { code: 'bo', name: 'Bolivia', flag: '🇧🇴', currency: 'BOB', useUF: false, lang: 'es', ivaRate: 0.13, priceMultiplier: 1.0 },
    { code: 'ar', name: 'Argentina', flag: '🇦🇷', currency: 'USD', useUF: false, lang: 'es', ivaRate: 0.21, priceMultiplier: 1.0 },
    // Brasil ahora usa 'pt' como idioma
    { code: 'br', name: 'Brasil', flag: '🇧🇷', currency: 'BRL', useUF: false, lang: 'pt', ivaRate: 0.18, priceMultiplier: 1.0 },
    { code: 'co', name: 'Colombia', flag: '🇨🇴', currency: 'COP', useUF: false, lang: 'es', ivaRate: 0.19, priceMultiplier: 1.0 },
    { code: 'pe', name: 'Perú', flag: '🇵🇪', currency: 'PEN', useUF: false, lang: 'es', ivaRate: 0.18, priceMultiplier: 1.0 },
    { code: 'py', name: 'Paraguay', flag: '🇵🇾', currency: 'PYG', useUF: false, lang: 'es', ivaRate: 0.10, priceMultiplier: 1.0 },

    // --- Precios Elevados (1.3x - 1.8x) ---
    { code: 'mx', name: 'México', flag: '🇲🇽', currency: 'MXN', useUF: false, lang: 'es', ivaRate: 0.16, priceMultiplier: 1.3 }, // +30%
    { code: 'es', name: 'España', flag: '🇪🇸', currency: 'EUR', useUF: false, lang: 'es', ivaRate: 0.21, priceMultiplier: 1.5 }, // +50%
    { code: 'us', name: 'USA', flag: '🇺🇸', currency: 'USD', useUF: false, lang: 'en', ivaRate: 0.08, priceMultiplier: 1.8 }  // +80%
  ];
  public selectedCountry: any;
  // --- FIN LÓGICA i18n ---

  // Colores específicos para cada plan (Visualización Gráfico y Botones)
  private planColors = [
    '#00FFFF', '#00FFFF', // Básico, Estándar (Cian Galáctico)
    '#00FFA3', '#00FFA3', // Pro, Empresa (Verde Aurora)
    '#BC13FE', '#BC13FE', // Premium, Corporativo (Púrpura Nebulosa)
    '#FFD700', '#FFD700', // Elite, Ultimate (Oro Estelar)
    '#FF2A68', '#FF2A68'  // BIP, Quantum (Rojo Supernova)
  ];

  private data = {
    "config": {
      "UF_TO_CLP": 38000,
      "IVA_RATE": 0.19,
      "exchangeRates": {
        "UF_TO_USD": 40,
        "UF_TO_EUR": 38,
        "UF_TO_MXN": 720,
        "UF_TO_BRL": 205,
        "UF_TO_BOB": 278,
        "UF_TO_COP": 155000,
        "UF_TO_PEN": 150,
        "UF_TO_PYG": 300000
      }
    },
    "almacenamiento": [
      { "id": "100gb", "capacidad": "100 GB", "costoUF": 0.40 }, { "id": "250gb", "capacidad": "250 GB", "costoUF": 0.97 },
      { "id": "500gb", "capacidad": "500 GB", "costoUF": 1.95 }, { "id": "1tb", "capacidad": "1 TB", "costoUF": 3.90 },
      { "id": "2tb", "capacidad": "2 TB", "costoUF": 7.80 }, { "id": "5tb", "capacidad": "5 TB", "costoUF": 19.50 },
      { "id": "10tb", "capacidad": "10 TB", "costoUF": 39.00 }, { "id": "20tb", "capacidad": "20 TB", "costoUF": 78.00 },
      { "id": "50tb", "capacidad": "50 TB", "costoUF": 195.00 }, { "id": "100tb", "capacidad": "100 TB", "costoUF": 390.00 }
    ],
    "gemini": [
      { "id": "basico-ia", "nombre": "Básico IA", "costoUF": 0.005 }, { "id": "estandar-ia", "nombre": "Estándar IA", "costoUF": 0.01 },
      { "id": "pro-ia", "nombre": "Pro IA", "costoUF": 0.05 }, { "id": "empresa-ia", "nombre": "Empresa IA", "costoUF": 0.10 },
      { "id": "premium-ia", "nombre": "Premium IA", "costoUF": 0.49 }, { "id": "corporativo-ia", "nombre": "Corporativo IA", "costoUF": 0.97 },
      { "id": "elite-ia", "nombre": "Elite IA", "costoUF": 1.95 }, { "id": "ultimate-ia", "nombre": "Ultimate IA", "costoUF": 4.88 },
      { "id": "bip-ia", "nombre": "BIP IA", "costoUF": 9.75 }, { "id": "quantum-ia", "nombre": "Quantum IA", "costoUF": 19.50 }
    ],
    "maquinas": [
      { "id": "m1", "config": "4 vCPU, 16 GiB (Azure/AWS)", "costoUF_low": 7.5, "costoUF_high": 8.76 }, { "id": "m2", "config": "8 vCPU, 32 GiB (Azure/AWS)", "costoUF_low": 14.0, "costoUF_high": 16.0 },
      { "id": "m3", "config": "16 vCPU, 64 GiB (Azure/AWS)", "costoUF_low": 27.5, "costoUF_high": 31.0 }, { "id": "m4", "config": "16 vCPU, 64 GiB (Opt. CPU) (Azure/AWS)", "costoUF_low": 30.0, "costoUF_high": 34.0 },
      { "id": "m5", "config": "8 vCPU, 64 GiB (Opt. RAM) (Azure/AWS)", "costoUF_low": 27.5, "costoUF_high": 32.5 }, { "id": "m6", "config": "16 vCPU, 128 GiB (Azure/AWS)", "costoUF_low": 55.0, "costoUF_high": 62.5 },
      { "id": "m7", "config": "32 vCPU, 256 GiB (Azure/AWS)", "costoUF_low": 110.0, "costoUF_high": 125.0 }, { "id": "m8", "config": "32 vCPU, 256 GiB (Opt. JVM) (Azure/AWS)", "costoUF_low": 140.0, "costoUF_high": 160.0 }
    ],
    "modulos": [
      { "id": "incidentes", "nombre": "Incidentes", "costoBaseUF": 100 }, { "id": "tarea", "nombre": "Tarea", "costoBaseUF": 60 },
      { "id": "requerimientos", "nombre": "Requerimientos", "costoBaseUF": 100 }, { "id": "problemas", "nombre": "Problemas", "costoBaseUF": 70 },
      { "id": "agente-virtual", "nombre": "Agente Virtual", "costoBaseUF": 70 }, { "id": "cotizaciones", "nombre": "Cotizaciones", "costoBaseUF": 60 },
      { "id": "grafana", "nombre": "Grafana", "costoBaseUF": 50 }, { "id": "planificacion-gestion-activos", "nombre": "Planificación y Gestión de Activos", "costoBaseUF": 70 }
    ],
    "planes": [
      { "nombre": "Básico", "usuarios": 300, "modulos": [{ "id": "incidentes", "costoUF": 7 }, { "id": "tarea", "costoUF": 2 }, { "id": "requerimientos", "costoUF": 7 }, { "id": "problemas", "costoUF": 7 }, { "id": "agente-virtual", "costoUF": 2 }, { "id": "cotizaciones", "costoUF": 7 }], "maquinaId": "m1", "almacenamientoId": "100gb", "geminiId": "basico-ia" },
      { "nombre": "Estándar", "usuarios": 1000, "modulos": [{ "id": "incidentes", "costoUF": 12 }, { "id": "tarea", "costoUF": 3 }, { "id": "requerimientos", "costoUF": 15 }, { "id": "problemas", "costoUF": 9 }, { "id": "agente-virtual", "costoUF": 6 }, { "id": "cotizaciones", "costoUF": 9 }], "maquinaId": "m1", "almacenamientoId": "250gb", "geminiId": "estandar-ia" },
      { "nombre": "Pro", "usuarios": 5000, "modulos": [{ "id": "incidentes", "costoUF": 50 }, { "id": "tarea", "costoUF": 10 }, { "id": "requerimientos", "costoUF": 40 }, { "id": "problemas", "costoUF": 10 }, { "id": "agente-virtual", "costoUF": 10 }, { "id": "cotizaciones", "costoUF": 12 }], "maquinaId": "m1", "almacenamientoId": "500gb", "geminiId": "pro-ia" },
      { "nombre": "Empresa", "usuarios": 10000, "modulos": [{ "id": "incidentes", "costoUF": 60 }, { "id": "tarea", "costoUF": 15 }, { "id": "requerimientos", "costoUF": 50 }, { "id": "problemas", "costoUF": 15 }, { "id": "agente-virtual", "costoUF": 15 }, { "id": "cotizaciones", "costoUF": 15 }], "maquinaId": "m2", "almacenamientoId": "1tb", "geminiId": "empresa-ia" },
      { "nombre": "Premium", "usuarios": 20000, "modulos": [{ "id": "incidentes", "costoUF": 70 }, { "id": "tarea", "costoUF": 20 }, { "id": "requerimientos", "costoUF": 70 }, { "id": "problemas", "costoUF": 20 }, { "id": "agente-virtual", "costoUF": 19 }, { "id": "cotizaciones", "costoUF": 20 }], "maquinaId": "m3", "almacenamientoId": "2tb", "geminiId": "premium-ia" },
      { "nombre": "Corporativo", "usuarios": 30000, "modulos": [{ "id": "incidentes", "costoUF": 80 }, { "id": "tarea", "costoUF": 25 }, { "id": "requerimientos", "costoUF": 80 }, { "id": "problemas", "costoUF": 30 }, { "id": "agente-virtual", "costoUF": 23 }, { "id": "cotizaciones", "costoUF": 25 }, { "id": "planificacion-gestion-activos", "costoUF": 10 }], "maquinaId": "m4", "almacenamientoId": "5tb", "geminiId": "corporativo-ia" },
      { "nombre": "Elite", "usuarios": 40000, "modulos": [{ "id": "incidentes", "costoUF": 90 }, { "id": "tarea", "costoUF": 30 }, { "id": "requerimientos", "costoUF": 90 }, { "id": "problemas", "costoUF": 40 }, { "id": "agente-virtual", "costoUF": 27 }, { "id": "cotizaciones", "costoUF": 30 }, { "id": "grafana", "costoUF": 20 }, { "id": "planificacion-gestion-activos", "costoUF": 20 }], "maquinaId": "m5", "almacenamientoId": "10tb", "geminiId": "elite-ia" },
      { "nombre": "Ultimate", "usuarios": 60000, "modulos": [{ "id": "incidentes", "costoUF": 100 }, { "id": "tarea", "costoUF": 40 }, { "id": "requerimientos", "costoUF": 100 }, { "id": "problemas", "costoUF": 50 }, { "id": "agente-virtual", "costoUF": 32 }, { "id": "cotizaciones", "costoUF": 40 }, { "id": "grafana", "costoUF": 30 }, { "id": "planificacion-gestion-activos", "costoUF": 40 }], "maquinaId": "m6", "almacenamientoId": "20tb", "geminiId": "ultimate-ia" },
      { "nombre": "BIP", "usuarios": 80000, "modulos": [{ "id": "incidentes", "costoUF": 100 }, { "id": "tarea", "costoUF": 50 }, { "id": "requerimientos", "costoUF": 100 }, { "id": "problemas", "costoUF": 60 }, { "id": "agente-virtual", "costoUF": 36 }, { "id": "cotizaciones", "costoUF": 50 }, { "id": "grafana", "costoUF": 40 }, { "id": "planificacion-gestion-activos", "costoUF": 60 }], "maquinaId": "m7", "almacenamientoId": "50tb", "geminiId": "bip-ia" },
      { "nombre": "Quantum", "usuarios": 100000, "modulos": [{ "id": "incidentes", "costoUF": 100 }, { "id": "tarea", "costoUF": 60 }, { "id": "requerimientos", "costoUF": 100 }, { "id": "problemas", "costoUF": 70 }, { "id": "agente-virtual", "costoUF": 40 }, { "id": "cotizaciones", "costoUF": 60 }, { "id": "grafana", "costoUF": 50 }, { "id": "planificacion-gestion-activos", "costoUF": 70 }], "maquinaId": "m8", "almacenamientoId": "100tb", "geminiId": "quantum-ia" }
    ]
  };

  constructor(private fb: FormBuilder,
    private contactService: ContactService,
    private fix: LandingFixService,
    private route: ActivatedRoute,
    private title: Title,
    private meta: Meta,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    // Setea el país por defecto (Chile)
    this.selectedCountry = this.countries.find(c => c.code === 'cl');
    this.currentLang = 'es';

    this.contactForm = this.fb.group({
      name: [''],
      phone: [''],
      email: ['', [Validators.required, Validators.email]]
    });
    this.processData();
  }

  ngAfterViewInit() {
    this.showTab(this.activeTab);
  }

  ngOnDestroy() {
    this.destroyChart();
  }

  /**
   * Obtiene el objeto de traducción actual
   */
  get t() {
    return translations[this.currentLang];
  }

  /**
   * Cambia la región (país, moneda e idioma)
   */
  public setRegion(event: any) {
    const countryCode = event.target.value;
    this.selectedCountry = this.countries.find(c => c.code === countryCode);
    this.currentLang = this.selectedCountry.lang;

    // Actualizar todos los datos y vistas
    this.processData(); // Recalcular costos
    this.showTab(this.activeTab); // Renderizar de nuevo la pestaña activa
    this.calculatePlan(); // Recalcular plan recomendado
    this.calculateTotalModuleCost(); // Recalcular cotizador
  }

  /**
   * Convierte un valor de UF a la moneda local seleccionada,
   * APLICANDO EL MULTIPLICADOR DE PRECIO REGIONAL.
   */
  private getConvertedCost(ufValue: number): number {
    const adjustedUfValue = ufValue * this.selectedCountry.priceMultiplier;
    if (this.selectedCountry.useUF) {
      return adjustedUfValue;
    }

    if (this.selectedCountry.currency === 'CLP') {
      return adjustedUfValue * this.data.config.UF_TO_CLP;
    }

    const rateKey = `UF_TO_${this.selectedCountry.currency}`;
    const rate = this.data.config.exchangeRates[rateKey];
    if (rate) {
      return adjustedUfValue * rate;
    }
    return adjustedUfValue * this.data.config.exchangeRates.UF_TO_USD;
  }

  /**
   * Formatea un número como moneda local
   */
  private formatCurrency(value: number): string {
    if (isNaN(value)) return '--';

    const currency = this.selectedCountry.currency;
    let lang = this.currentLang === 'es' ? 'es-CL' : 'en-US';

    if (this.currentLang === 'pt') lang = 'pt-BR';
    if (currency === 'EUR') lang = 'es-ES';
    if (currency === 'USD') lang = 'en-US';
    if (currency === 'MXN') lang = 'es-MX';
    if (currency === 'BRL') lang = 'pt-BR';
    if (currency === 'BOB') lang = 'es-BO';
    if (currency === 'COP') lang = 'es-CO';
    if (currency === 'PEN') lang = 'es-PE';
    if (currency === 'PYG') lang = 'es-PY';

    if (currency === 'UF') {
      return new Intl.NumberFormat('es-CL', { maximumFractionDigits: 2 }).format(value) + ' UF';
    }

    return new Intl.NumberFormat(lang, {
      style: 'currency',
      currency: currency,
      maximumFractionDigits: (currency === 'COP' || currency === 'MXN' || currency === 'PYG') ? 0 : 2
    }).format(value);
  }

  private destroyChart() {
    if (this.myChart) {
      this.myChart.destroy();
      this.myChart = null;
    }
  }

  showTab(tabId: string) {
    this.activeTab = tabId;
    this.cdr.detectChanges();

    setTimeout(() => {
      if (tabId === 'cotizaciones') this.renderQuotesTable();
      if (tabId === 'graficos') {
        this.createButtons();
        this.renderPriceComparisonChart();
        if (this.data.planes.length > 0) this.selectPlan(0);
      }
      if (tabId === 'calculadora') this.populateModuleCalculator();
    }, 0);
  }

  private processData() {
    this.data.planes.forEach((plan: any) => {
      plan.costoModulosUF = plan.modulos.reduce((sum, mod) => sum + mod.costoUF, 0);
      plan.costoMonedaLocal = this.getConvertedCost(plan.costoModulosUF);
    });
  }

  private renderQuotesTable() {
    const table = document.getElementById('tabla-cotizaciones');
    if (!table) return;
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');
    thead.innerHTML = '';
    tbody.innerHTML = '';

    const currency = this.selectedCountry.currency;

    const headers = ['Plan', 'Usuarios', 'Licencias (25%)', `Costo Módulos (${currency})`, ...this.data.modulos.map(m => `Costo ${m.nombre} (${currency})`), 'Storage', `Máquinas (${currency})`, `IA Gemini (${currency})`];
    const headerRow = document.createElement('tr');
    headers.forEach(text => {
      const th = document.createElement('th');
      th.textContent = text;
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);

    this.data.planes.forEach((plan: any) => {
      const row = document.createElement('tr');
      const maquina = this.data.maquinas.find(m => m.id === plan.maquinaId);
      const storage = this.data.almacenamiento.find(a => a.id === plan.almacenamientoId);
      const geminiPlan = this.data.gemini.find(g => g.id === plan.geminiId);

      const costoModulos = this.formatCurrency(plan.costoMonedaLocal);
      const storageCost = this.formatCurrency(this.getConvertedCost(storage.costoUF));
      const machineCostLow = this.formatCurrency(this.getConvertedCost(maquina.costoUF_low));
      const machineCostHigh = this.formatCurrency(this.getConvertedCost(maquina.costoUF_high));
      const geminiCost = this.formatCurrency(this.getConvertedCost(geminiPlan.costoUF));

      let cells = `<th>${plan.nombre}</th><td>${plan.usuarios.toLocaleString()}</td><td>${(plan.usuarios * 0.25).toLocaleString()}</td><td>${costoModulos}</td>`;

      this.data.modulos.forEach(moduloBase => {
        const planModule = plan.modulos.find(pm => pm.id === moduloBase.id);
        const modCost = planModule ? this.formatCurrency(this.getConvertedCost(planModule.costoUF)) : '—';
        cells += `<td>${modCost}</td>`;
      });

      cells += `<td>${storage.capacidad} (~${storageCost})</td><td>${machineCostLow} - ${machineCostHigh}</td><td>~${geminiCost}</td>`;
      row.innerHTML = cells;
      tbody.appendChild(row);
    });
  }

  private renderPriceComparisonChart() {
    const canvas = document.getElementById('priceComparisonChart') as HTMLCanvasElement;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    this.destroyChart();

    const currency = this.selectedCountry.currency;
    const chartData = this.data.planes.map((plan: any) => plan.costoMonedaLocal);

    this.myChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.data.planes.map((plan: any) => plan.nombre),
        datasets: [{
          label: `${this.t.costSummaryTitle} (${currency})`,
          data: chartData,
          // Usamos los colores definidos con un poco de transparencia para el relleno
          backgroundColor: this.planColors.map(c => c + '99'),
          borderColor: this.planColors,
          borderWidth: 2,
          hoverBackgroundColor: this.planColors, // Color sólido al pasar el mouse
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          labels: { fontColor: '#e0f7ff', fontFamily: "'Inter', sans-serif" }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#e0f7ff',
              fontFamily: "'Inter', sans-serif",
              callback: value => this.formatCurrency(value)
            },
            gridLines: { color: 'rgba(255, 255, 255, 0.1)' }
          }],
          xAxes: [{
            ticks: { fontColor: '#e0f7ff', fontFamily: "'Inter', sans-serif" },
            gridLines: { display: false }
          }]
        },
        tooltips: {
          enabled: true,
          mode: 'index',
          intersect: false,
          backgroundColor: 'rgba(2, 0, 26, 0.9)',
          borderColor: '#00f0f0',
          borderWidth: 1,
          titleFontColor: '#00f0f0',
          titleFontFamily: "'Exo 2', sans-serif",
          bodyFontColor: '#e0f7ff',
          bodyFontFamily: "'Inter', sans-serif",
          callbacks: {
            label: (tooltipItem, data) => {
              let label = data.datasets[tooltipItem.datasetIndex].label || '';
              if (label) {
                label += ': ';
              }
              label += this.formatCurrency(Number(tooltipItem.yLabel));
              return label;
            }
          }
        }
      }
    });
  }

  private createButtons() {
    const buttonContainer = document.getElementById('plan-buttons');
    if (!buttonContainer) return;
    buttonContainer.innerHTML = '';
    this.data.planes.forEach((plan, index) => {
      const button = document.createElement('button');
      // Insertamos un círculo (span) y el nombre del plan
      button.innerHTML = `<span class="plan-dot"></span>${plan.nombre}`;
      button.className = 'plan-button';

      // Asignamos el color específico como variable CSS a este botón
      button.style.setProperty('--neon-color', this.planColors[index] || '#00f0f0');

      button.onclick = () => this.selectPlan(index);
      buttonContainer.appendChild(button);
    });
  }

  private selectPlan(planIndex: number) {
    if (planIndex < 0 || planIndex >= this.data.planes.length) {
      planIndex = 0;
    }
    const plan: any = this.data.planes[planIndex];
    if (!plan) return;

    document.getElementById('plan-name').textContent = plan.nombre;
    document.getElementById('plan-price').textContent = this.formatCurrency(plan.costoMonedaLocal);
    document.querySelectorAll('.plan-button').forEach((button, index) => {
      button.classList.toggle('active', index === planIndex);
    });
  }

  public calculatePlan() {
    const userInput = document.getElementById('user-input') as HTMLInputElement;
    if (!userInput) return;
    const userCount = parseInt(userInput.value, 10);

    const resultTextEl = document.getElementById('result-text');

    if (isNaN(userCount) || userCount <= 0) {
      this.recommendationResult = true;
      if (resultTextEl) resultTextEl.innerHTML = "Por favor, ingrese un número de usuarios válido.";

      ['ngcloud-cost', 'machine-cost-range', 'storage-cost', 'gemini-cost-rec', 'total-cost-range', 'iva-cost-range', 'final-total-cost-range'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.textContent = '--';
      });
      const moduleList = document.getElementById('module-list');
      if (moduleList) moduleList.innerHTML = '';
      return;
    }

    this.recommendationResult = true;
    const recommendedPlan: any = this.data.planes.find((p: any) => userCount <= p.usuarios) || this.data.planes[this.data.planes.length - 1];
    const machine = this.data.maquinas.find(m => m.id === recommendedPlan.maquinaId);
    const storage = this.data.almacenamiento.find(s => s.id === recommendedPlan.almacenamientoId);
    const geminiPlan = this.data.gemini.find(g => g.id === recommendedPlan.geminiId);

    const costoModulos = this.getConvertedCost(recommendedPlan.costoModulosUF);
    const machineLow = this.getConvertedCost(machine.costoUF_low);
    const machineHigh = this.getConvertedCost(machine.costoUF_high);
    const storageCost = this.getConvertedCost(storage.costoUF);
    const geminiCost = this.getConvertedCost(geminiPlan.costoUF);

    const totalLow = this.getConvertedCost(recommendedPlan.costoModulosUF + machine.costoUF_low + storage.costoUF + geminiPlan.costoUF);
    const totalHigh = this.getConvertedCost(recommendedPlan.costoModulosUF + machine.costoUF_high + storage.costoUF + geminiPlan.costoUF);
    const ivaLow = totalLow * this.selectedCountry.ivaRate;
    const ivaHigh = totalHigh * this.selectedCountry.ivaRate;

    if (resultTextEl) resultTextEl.innerHTML = `${this.t.recommendationResultTitle} <strong>${userCount.toLocaleString()}</strong> ${this.t.recommendationResultTitleUsers} <strong>${recommendedPlan.nombre}</strong>.`;

    document.getElementById('ngcloud-cost').textContent = this.formatCurrency(costoModulos);
    document.getElementById('machine-cost-range').textContent = `${this.formatCurrency(machineLow)} - ${this.formatCurrency(machineHigh)}`;
    document.getElementById('storage-cost').textContent = `${storage.capacidad} (~${this.formatCurrency(storageCost)})`;
    document.getElementById('gemini-cost-rec').textContent = `${geminiPlan.nombre} (~${this.formatCurrency(geminiCost)})`;

    document.getElementById('total-cost-range').textContent = `${this.formatCurrency(totalLow)} - ${this.formatCurrency(totalHigh)}`;
    document.getElementById('iva-cost-range').textContent = `${this.formatCurrency(ivaLow)} - ${this.formatCurrency(ivaHigh)}`;
    document.getElementById('final-total-cost-range').textContent = `${this.formatCurrency(totalLow + ivaLow)} - ${this.formatCurrency(totalHigh + ivaHigh)}`;

    document.getElementById('iva-label').textContent = `${this.t.ivaLabel} (${(this.selectedCountry.ivaRate * 100).toFixed(0)}%):`;

    const moduleList = document.getElementById('module-list');
    moduleList.innerHTML = '';
    recommendedPlan.modulos.forEach(modInfo => {
      const modDetails = this.data.modulos.find(m => m.id === modInfo.id);
      const listItem = document.createElement('li');
      const modCost = this.formatCurrency(this.getConvertedCost(modInfo.costoUF));
      listItem.textContent = `${modDetails.nombre} (${modCost})`;
      moduleList.appendChild(listItem);
    });

    this.updateModuleCalculatorForPlan(recommendedPlan);
  }

  private populateModuleCalculator() {
    this.populateSelect('plan-select', this.data.planes, (plan: any, index) => `${plan.nombre} (hasta ${plan.usuarios.toLocaleString()} usuarios)`, (item, index) => index.toString());
    this.populateSelect('machine-select', this.data.maquinas, (m) => `${m.config}: ~${this.formatCurrency(this.getConvertedCost(m.costoUF_low))} - ~${this.formatCurrency(this.getConvertedCost(m.costoUF_high))}`, (item) => item.id);
    this.populateSelect('storage-select', this.data.almacenamiento, (s) => `${s.capacidad} (~${this.formatCurrency(this.getConvertedCost(s.costoUF))})`, (item) => item.id);
    this.populateSelect('gemini-select', this.data.gemini, (g) => `${g.nombre} (~${this.formatCurrency(this.getConvertedCost(g.costoUF))})`, (item) => item.id);

    this.populateModulesList();

    document.getElementById('plan-select')?.addEventListener('change', () => this.updateCalculatorFromPlanSelection());
    document.getElementById('machine-select')?.addEventListener('change', () => this.calculateTotalModuleCost());
    document.getElementById('storage-select')?.addEventListener('change', () => this.calculateTotalModuleCost());
    document.getElementById('gemini-select')?.addEventListener('change', () => this.calculateTotalModuleCost());

    this.updateCalculatorFromPlanSelection();
  }

  private populateSelect(selectId, items, textFn, valueFn) {
    const select = document.getElementById(selectId) as HTMLSelectElement;
    if (!select) return;
    select.innerHTML = '';
    items.forEach((item, index) => {
      const option = document.createElement('option');
      option.textContent = textFn(item, index);
      option.value = valueFn(item, index);
      select.appendChild(option);
    });
  }

  private populateModulesList() {
    const container = document.getElementById('modulos-list');
    if (!container) return;
    container.innerHTML = '';
    this.data.modulos.forEach(mod => {
      const div = document.createElement('div');
      const costUF = mod.costoBaseUF;
      const costLocal = this.formatCurrency(this.getConvertedCost(costUF));

      div.innerHTML = `
            <label class="checkbox-label">
                <input type="checkbox" data-id="${mod.id}" data-cost-uf="${costUF}" class="checkbox-input">
                <span>${mod.nombre} (<span class="font-bold module-cost-local">${costLocal}</span>)</span>
            </label>
        `;
      div.querySelector('input').addEventListener('change', () => this.calculateTotalModuleCost());
      container.appendChild(div);
    });
  }

  public toggleGeminiSection() {
    const checkbox = document.getElementById('gemini-enable-checkbox') as HTMLInputElement;
    const container = document.getElementById('gemini-options-container') as HTMLElement;
    if (container) container.style.display = checkbox.checked ? 'block' : 'none';
    this.calculateTotalModuleCost();
  }

  private updateCalculatorFromPlanSelection() {
    const planSelect = document.getElementById('plan-select') as HTMLSelectElement;
    if (!planSelect) return;
    const planIndex = parseInt(planSelect.value, 10);
    const selectedPlan: any = this.data.planes[planIndex];

    document.querySelectorAll('#modulos-list input[type="checkbox"]').forEach((cb: HTMLInputElement) => {
      const modId = cb.dataset.id;
      const planModule = selectedPlan.modulos.find(m => m.id === modId);
      cb.checked = !!planModule;

      const costUF = planModule ? planModule.costoUF : this.data.modulos.find(m => m.id === modId).costoBaseUF;
      cb.dataset.costUf = costUF.toString();

      const costEl = cb.closest('label').querySelector('.module-cost-local');
      if (costEl) costEl.textContent = this.formatCurrency(this.getConvertedCost(costUF));
    });

    (document.getElementById('machine-select') as HTMLSelectElement).value = selectedPlan.maquinaId;
    (document.getElementById('storage-select') as HTMLSelectElement).value = selectedPlan.almacenamientoId;
    (document.getElementById('gemini-select') as HTMLSelectElement).value = selectedPlan.geminiId;

    const geminiCheckbox = document.getElementById('gemini-enable-checkbox') as HTMLInputElement;
    if (geminiCheckbox) {
      geminiCheckbox.checked = true;
      this.toggleGeminiSection();
    }
  }

  private updateModuleCalculatorForPlan(plan) {
    const planSelect = document.getElementById('plan-select') as HTMLSelectElement;
    if (!planSelect) return;
    if (plan) {
      const planIndex = this.data.planes.findIndex(p => p.nombre === plan.nombre);
      if (planIndex !== -1) planSelect.value = planIndex.toString();
    } else {
      planSelect.value = '0';
    }
    this.updateCalculatorFromPlanSelection();
  }

  private calculateTotalModuleCost() {
    const machineId = (document.getElementById('machine-select') as HTMLSelectElement)?.value;
    const storageId = (document.getElementById('storage-select') as HTMLSelectElement)?.value;
    const geminiId = (document.getElementById('gemini-select') as HTMLSelectElement)?.value;

    const machine = this.data.maquinas.find(m => m.id === machineId);
    const storage = this.data.almacenamiento.find(s => s.id === storageId);
    let geminiCostUF = 0;
    if ((document.getElementById('gemini-enable-checkbox') as HTMLInputElement)?.checked) {
      const geminiPlan = this.data.gemini.find(g => g.id === geminiId);
      if (geminiPlan) geminiCostUF = parseFloat(geminiPlan.costoUF.toString());
    }

    const machineCostLowUF = machine ? parseFloat(machine.costoUF_low.toString()) : 0;
    const machineCostHighUF = machine ? parseFloat(machine.costoUF_high.toString()) : 0;
    const storageCostUF = storage ? parseFloat(storage.costoUF.toString()) : 0;

    let modulesCostUF = 0;
    document.querySelectorAll('#modulos-list input:checked').forEach((cb: HTMLInputElement) => {
      modulesCostUF += parseFloat(cb.dataset.costUf);
    });

    const machineCostLow = this.getConvertedCost(machineCostLowUF);
    const machineCostHigh = this.getConvertedCost(machineCostHighUF);
    const modulesCost = this.getConvertedCost(modulesCostUF);
    const storageCost = this.getConvertedCost(storageCostUF);
    const geminiCost = this.getConvertedCost(geminiCostUF);

    const subtotalLow = this.getConvertedCost(machineCostLowUF + modulesCostUF + storageCostUF + geminiCostUF);
    const subtotalHigh = this.getConvertedCost(machineCostHighUF + modulesCostUF + storageCostUF + geminiCostUF);
    const ivaLow = subtotalLow * this.selectedCountry.ivaRate;
    const ivaHigh = subtotalHigh * this.selectedCountry.ivaRate;

    document.getElementById('machine-cost').textContent = `${this.formatCurrency(machineCostLow)} - ${this.formatCurrency(machineCostHigh)}`;
    document.getElementById('modules-cost').textContent = this.formatCurrency(modulesCost);
    document.getElementById('storage-cost-calc').textContent = this.formatCurrency(storageCost);
    document.getElementById('gemini-cost-calc').textContent = this.formatCurrency(geminiCost);
    document.getElementById('subtotal-cost').textContent = `${this.formatCurrency(subtotalLow)} - ${this.formatCurrency(subtotalHigh)}`;
    document.getElementById('iva-cost').textContent = `${this.formatCurrency(ivaLow)} - ${this.formatCurrency(ivaHigh)}`;
    document.getElementById('final-cost').textContent = `${this.formatCurrency(subtotalLow + ivaLow)} - ${this.formatCurrency(subtotalHigh + ivaHigh)}`;

    document.getElementById('iva-label-calc').textContent = `${this.t.ivaLabel} (${(this.selectedCountry.ivaRate * 100).toFixed(0)}%):`;
  }

  public sendEmailQuote(): void {
    console.log('Enviando correo con la cotización...');
    this.sendEmail = true;

    const selectedPlanText = (document.getElementById('plan-select') as HTMLSelectElement).options[(document.getElementById('plan-select') as HTMLSelectElement).selectedIndex].text;
    const selectedMachineText = (document.getElementById('machine-select') as HTMLSelectElement).options[(document.getElementById('machine-select') as HTMLSelectElement).selectedIndex].text.split(':')[0];
    const selectedStorageText = (document.getElementById('storage-select') as HTMLSelectElement).options[(document.getElementById('storage-select') as HTMLSelectElement).selectedIndex].text.split('(')[0];
    const geminiEnabled = (document.getElementById('gemini-enable-checkbox') as HTMLInputElement).checked;
    const selectedGeminiText = (document.getElementById('gemini-select') as HTMLSelectElement).options[(document.getElementById('gemini-select') as HTMLSelectElement).selectedIndex].text.split('(')[0];

    let selectedModules = [];
    document.querySelectorAll('#modulos-list input:checked').forEach((cb: HTMLInputElement) => {
      const label = cb.closest('label').querySelector('span').textContent;
      const [name, cost] = label.split('(');
      selectedModules.push({ name: name.trim(), cost: cost.replace(')', '').trim() });
    });

    const machineCost = document.getElementById('machine-cost').textContent;
    const modulesCost = document.getElementById('modules-cost').textContent;
    const storageCost = document.getElementById('storage-cost-calc').textContent;
    const geminiCost = document.getElementById('gemini-cost-calc').textContent;
    const subtotalCost = document.getElementById('subtotal-cost').textContent;
    const ivaCost = document.getElementById('iva-cost').textContent;
    const finalCost = document.getElementById('final-cost').textContent;
    const ivaLabel = document.getElementById('iva-label-calc').textContent;

    const modulesHtml = selectedModules.map(m => `<tr><td style="padding: 8px; border-bottom: 1px solid #4a5568;">- ${m.name}</td><td style="padding: 8px; border-bottom: 1px solid #4a5568; text-align: right;">${m.cost}</td></tr>`).join('');

    // EMAIL BODY CON TRADUCCIONES BÁSICAS
    const emailBody = `
      <!DOCTYPE html>
      <html lang="${this.currentLang}">
      <head>
        <meta charset="UTF-8">
        <title>${this.t.emailTitle}</title>
        <style>
          body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; margin: 0; padding: 0; background-color: #0c2b3a; color: #e0f7ff; }
          .container { max-width: 600px; margin: 20px auto; background-color: #1f2937; border-radius: 12px; padding: 25px; box-shadow: 0 5px 15px rgba(0,0,0,0.3); }
          .header { text-align: center; border-bottom: 1px solid #374151; padding-bottom: 15px; margin-bottom: 20px; }
          .header h1 { color: #00f0f0; margin: 0; }
          .section { margin-bottom: 20px; }
          .section h2 { color: #60a5fa; font-size: 1.2em; border-bottom: 2px solid #374151; padding-bottom: 8px; margin-top: 0; }
          .summary-table { width: 100%; border-collapse: collapse; }
          .summary-table td { padding: 10px 0; border-bottom: 1px solid #374151; }
          .summary-table tr:last-child td { border-bottom: none; }
          .summary-table .label { color: #cbd5e1; }
          .summary-table .value { text-align: right; font-weight: bold; }
          .total { font-size: 1.3em; font-weight: bold; color: #60a5fa; }
          .footer { text-align: center; margin-top: 25px; font-size: 0.8em; color: #9ca3af; }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <h1>${this.t.emailTitle}</h1>
          </div>
          <div class="section">
            <h2>${this.t.emailConfigTitle} (${this.t.regionLabel}: ${this.selectedCountry.name})</h2>
            <table class="summary-table">
              <tr><td class="label">${this.t.emailBasePlan}:</td><td class="value">${selectedPlanText}</td></tr>
              <tr><td class="label">${this.t.emailMachine}:</td><td class="value">${selectedMachineText}</td></tr>
              <tr><td class="label">${this.t.emailStorage}:</td><td class="value">${selectedStorageText}</td></tr>
              ${geminiEnabled ? `<tr><td class="label">${this.t.emailGemini}:</td><td class="value">${selectedGeminiText}</td></tr>` : `<tr><td class="label">${this.t.emailGemini}:</td><td class="value">${this.t.emailGeminiDisabled}</td></tr>`}
            </table>
          </div>
          ${selectedModules.length > 0 ? `
          <div class="section">
            <h2>${this.t.emailModulesTitle}</h2>
            <table style="width:100%; color: #e0f7ff;">
              <thead><tr><th style="text-align: left; padding: 8px; border-bottom: 2px solid #4a5568;">${this.t.emailModuleHeader}</th><th style="text-align: right; padding: 8px; border-bottom: 2px solid #4a5568;">${this.t.emailCostHeader}</th></tr></thead>
              <tbody>${modulesHtml}</tbody>
            </table>
          </div>
          ` : ''}
          <div class="section">
            <h2>${this.t.emailSummaryTitle} (${this.selectedCountry.currency})</h2>
            <table class="summary-table">
              <tr><td class="label">${this.t.machineCost}</td><td class="value">${machineCost}</td></tr>
              <tr><td class="label">${this.t.modulesCost}</td><td class="value">${modulesCost}</td></tr>
              <tr><td class="label">${this.t.storageCost}</td><td class="value">${storageCost}</td></tr>
              <tr><td class="label">${this.t.geminiCost}</td><td class="value">${geminiCost}</td></tr>
              <tr><td class="label"><strong>${this.t.subtotalNet}</strong></td><td class="value"><strong>${subtotalCost}</strong></td></tr>
              <tr><td class="label">${ivaLabel}</td><td class="value">${ivaCost}</td></tr>
              <tr><td class="label total">${this.t.finalTotal}</td><td class="value total">${finalCost}</td></tr>
            </table>
          </div>
          <div class="footer">
            <p>${this.t.emailDisclaimer}</p>
            <p>ngCloud &copy; ${new Date().getFullYear()}</p>
          </div>
        </div>
      </body>
      </html>
    `;
    let request = {
      name: this.contactForm.value.name,
      phone: this.contactForm.value.phone,
      email: this.contactForm.value.email,
      content: emailBody
    }

    this.contactService.sendEmail(request).subscribe((response: any) => {
      this.sendEmail = false;
      this.contactForm.reset();
      this._snackBar.open(response, response, {
        duration: 2000,
        panelClass: ['futuristic-snackbar']
      });
    }, err => {
      console.error('Error sending email:', err);
      this.sendEmail = false;
      this.showMessage(request.name + ', ' + 'ha ocurrido un problema.');
      if (!environment.production) console.log('ERROR sendEmail() = ' + JSON.stringify(err), 'REQUEST: ' + JSON.stringify(request))
    })
  }

  showMessage(message: string) {
    this._snackBar.open(message, '', {
      duration: 2000,
      panelClass: ['futuristic-snackbar-error']
    });
  }
}